<template>
    <a-config-provider :locale="antdLAN">
        <a-layout class="n-mvh-1"
                  v-if="browserSuport"
                  :class="'language-' + LANI">
            <a-layout class="n-layout-content n-flex n-flex-dr-c">
                <a-layout-header class="c-header-container n-flex-s">
                    <Header @organizationlogin="handleOrganizationLogin"
                            @personallogin="handlePersonalLogin"
                            @logout="handleLogout"
                            :organiztionHasAuth="organiztionHasAuth"
                            :userInfo="userInfo"></Header>
                </a-layout-header>
                <a-layout-content class="n-col-1 n-flex-g n-bg-2 n-scroll-v n-flex-g-h-1-hack"
                                  id="body"
                                  @scroll="bodyScroll">
                    <router-view v-slot="{ Component,route }">
                        <keep-alive>
                            <component :is="Component"
                                       :key="route.fullPath"
                                       @personallogin="handlePersonalLogin"
                                       ref="router" />
                        </keep-alive>
                    </router-view>
                </a-layout-content>
                <a-layout-footer class="n-bg-1 n-flex-s n-p-2 n-text-center c-shadow-1"
                                 style="position: relative;z-index: 10;">
                    <div class="n-flex n-flex-j-c c-max-width2 n-m-auto n-flex-a-c"
                         ref="footer">
                        <!-- <div class="n-m-0 n-text-center n-col-1"> -->
                        <span class="n-block">
                            {{ cr }}
                        </span>

                        <div class="n-flex n-ml-4 n-flex-j-c">
                            <a @click="showCookieManage=true"
                               target="_blank"
                               class="c-tab-link c-tab-link-event c-hover-line n-mr-4"
                               style="color:#0A87FD">Your Privacy Choices / Manage Cookies</a>
                            <a href="https://www.un-bug.com/"
                               target="_blank"
                               class="c-tab-link c-tab-link-event c-hover-line"
                               style="color:#0A87FD">Technical Support Pigeon Cloud</a>
                        </div>
                        <!-- </div> -->
                        <!-- <a-dropdown v-model:visible="showLanguage">
                            <span class="n-flex n-flex-a-c n-c-base n-pointer"
                                  @click.prevent>
                                {{LAN.languageStr[LANI]}}
                                <UpOutlined class="n-ml-1" />
                            </span>
                            <template #overlay>
                                <a-menu @click="e => {setLanguage(e.key); showLanguage = false}">
                                    <a-menu-item key="0">中文</a-menu-item>
                                    <a-menu-item key="1">English</a-menu-item>
                                </a-menu>
                            </template>
                        </a-dropdown> -->
                    </div>
                </a-layout-footer>
            </a-layout>
        </a-layout>

        <h1 v-else
            class="n-browser">{{LAN.nui.browser}}</h1>

        <a-back-top :visibilityHeight="100"
                    :target="() => body"
                    v-if="body">
            <a href="javascript:;"
               class="n-block n-radius-circle c-tab-link c-tab-link-event"
               style="width: 40px;height: 40px;background-color: rgba(0,0,0,.5);background-size: 60%;background-position: center;background-repeat: no-repeat;background-image: url(data:image/png;base64,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);"></a>
        </a-back-top>
    </a-config-provider>
    <ManageCookie v-model:visible="showCookieManage"></ManageCookie>
</template>
<script >
    import { mapMutations, mapState } from 'vuex';
    import zhCN from 'ant-design-vue/es/locale/zh_CN';
    import enUS from 'ant-design-vue/es/locale/en_US';
    import nui from '@/assets/script';
    import LAN from '@/assets/script/LAN';

    import { UpOutlined } from '@ant-design/icons-vue';
    import Header from '@/components/Header.vue'
    import { getStore, setStore, removeStore } from '@/assets/script/store';
    import { setToken, setRefreshToken, removeToken, removeRefreshToken, getRefreshToken } from '@/assets/script/auth'
    import ManageCookie from '@/components/ManageCookie.vue'

    export default {
        name: 'App',
        computed: {
            ...mapState(nui.extendVue.extendState.concat(['scrollInfo', 'windowWidth'])),

            /**
             * @description 检测浏览器兼容性
             */
            browserSuport () {
                var userAgent = navigator.userAgent,
                    ie6 = (/msie\s*(\d+)\.\d+/g.exec(userAgent.toLowerCase()) || [0, "0"])[1] == "6",
                    ie7 = userAgent.indexOf('MSIE 7.0') > -1,
                    ie8 = userAgent.indexOf('MSIE 8.0') > -1,
                    ie9 = userAgent.indexOf('MSIE 9.0') > -1;

                return !((ie6 || ie7 || ie8 || ie9) && location.href.indexOf('browser') <= 0)
            }
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                showLanguage: false,
                antdLAN: enUS,
                body: null,
                cr: '-',
                techweblink: "",
                userInfo: { nick_name: "", type: "" },
                organiztionHasAuth: false,
                showCookieManage: false
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat(['setWindowSize', 'setLevel', 'setStatus', 'setScroll', 'setIsMobileByWinWidth'])),

            async NMounted () {
                window.addEventListener('resize', this.setWindowSize)

                this.$nextTick(() => {
                    this.body = document.getElementById('body')
                })

                await this.checkLogin();

                this.request(this.API.cr, {
                    autoCancel: false
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.cr = res.data.paramValue;
                    }
                });

                this.request(this.API.techweblink, {
                    autoCancel: false
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.techweblink = res.data.paramValue;
                    }
                });

                this.setIsMobileByWinWidth()

                window.onresize = () => {
                    this.setIsMobileByWinWidth()
                }

                // this.setLanguage(navigator.language == 'zh-CN' ? 0 : 1)
                // this.antdLAN = navigator.language == 'zh-CN' ? zhCN : enUS;

                this.setLanguage(1)
                this.antdLAN = enUS;

                this.$nextTick(() => {
                    var menu = document.getElementById('menu');

                    if (menu) {
                        menu.style.width = menu.offsetWidth + 'px'
                    }
                })

                // document.addEventListener('keydown', (e) => {
                //     if (e.key.toLowerCase() == 'enter') {
                //         // if (e.target.classList.contains('c-tab-link-event')) {
                //         //     e.target.click()
                //         // }

                //         // if (document.activeElement && document.activeElement.classList.contains('c-tab-link-event')) {
                //         //     document.activeElement.blur()
                //         // }
                //     }
                // })

                document.addEventListener('mouseup', (e) => {
                    if (document.activeElement && (
                        document.activeElement.classList.contains('c-tab-link-event') ||
                        document.activeElement.classList.contains('ant-collapse-header') ||
                        document.activeElement.classList.contains('ant-tabs-tab-btn') ||
                        document.activeElement.tagName.toLowerCase() == 'a'
                    )) {
                        document.activeElement.blur()
                    }
                })

                document.addEventListener('focusin', (e) => {
                    var parentMenu = e.target.parentNode.parentNode.parentNode,
                        parentNode = e.target.parentNode

                    if (parentNode.classList.contains('c-menu-with-children')) {
                        parentNode.classList.add('c-tab-link-focus-parent')
                    }

                    if (parentMenu.classList.contains('c-menu-with-children')) {
                        parentMenu.classList.add('c-tab-link-focus-parent')
                    }
                });

                document.addEventListener('focusout', (e) => {
                    var parentMenu = e.target.parentNode.parentNode.parentNode,
                        parentNode = e.target.parentNode

                    if (parentNode.classList.contains('c-menu-with-children')) {
                        parentNode.classList.remove('c-tab-link-focus-parent')
                    }

                    if (parentMenu.classList.contains('c-menu-with-children')) {
                        parentMenu.classList.remove('c-tab-link-focus-parent')
                    }
                });
            },
            menuMounted () {
                if (this.windowWidth > 992) {
                    var header = document.getElementById('header'),
                        menu = document.getElementById('menu');

                    menu.style.position = 'static'

                    if (menu.getBoundingClientRect().top - header.offsetHeight <= 0) {
                        menu.style.top = header.offsetHeight + 20 + 'px'
                        menu.style.position = 'fixed'
                    }

                    if (menu.querySelector('.c-content-left')) {
                        var h2 = menu.querySelector('h2') ? menu.querySelector('h2').offsetHeight : 0,
                            t = menu.getBoundingClientRect().top,
                            f = this.$refs.footer.offsetHeight,
                            all = h2 + t + f + 70;

                        menu.querySelector('.c-content-left').style.maxHeight = 'calc(100vh - ' + all + 'px)'
                    }
                }
            },
            titleMounted () {
                var header = document.getElementById('header'),
                    title = document.getElementById('title');

                title.style.position = 'absolute'
                title.style.top = '0'
                title.style.padding = "0"

                if (title && header) {
                    if (title.getBoundingClientRect().top - header.offsetHeight <= 0) {
                        title.style.top = header.offsetHeight + 'px'
                        title.style.position = 'fixed'

                        if (this.isMobileByWinWidth) {
                            title.style.padding = "10px 0"
                        } else {
                            title.style.padding = "0"
                        }
                    }
                }
            },
            sortMounted () {
                var header = document.getElementById('header'),
                    sort = document.getElementById('sort');

                sort.style.position = 'absolute'
                sort.style.top = '0'
                sort.style.padding = "0"

                if (sort && header) {
                    if (sort.getBoundingClientRect().top - header.offsetHeight <= 0) {
                        sort.style.top = header.offsetHeight + 'px'
                        sort.style.position = 'fixed'

                        if (this.isMobileByWinWidth) {
                            sort.style.padding = "10px 0"
                        } else {
                            sort.style.padding = "10px"
                        }
                    }
                }
            },
            bodyScroll (e) {
                var type = e.target.scrollTop > this.scrollInfo.y ? 'down' : 'up'

                this.setScroll({ y: e.target.scrollTop })

                var menu = document.getElementById('menu'),
                    header = document.getElementById('header'),
                    sort = document.getElementById('sort'),
                    title = document.getElementById('title');

                if (menu) {
                    menu.style.width = menu.offsetWidth + 'px'
                }

                if (menu && header && this.windowWidth > 992) {
                    if (type == 'down') {
                        if (menu.getBoundingClientRect().top - header.offsetHeight <= 0) {
                            menu.style.top = header.offsetHeight + parseInt(menu.getAttribute('os') || 20) + 'px'
                            menu.style.position = 'fixed'

                            if (menu.querySelector('.c-content-left')) {
                                var h2 = menu.querySelector('h2') ? menu.querySelector('h2').offsetHeight : 0,
                                    t = menu.getBoundingClientRect().top,
                                    f = this.$refs.footer.offsetHeight,
                                    all = h2 + t + f + 70;

                                menu.querySelector('.c-content-left').style.maxHeight = 'calc(100vh - ' + all + 'px)'
                            }
                        }
                    } else {
                        if (e.target.scrollTop <= 20) {
                            menu.style.position = 'static'

                            if (menu.querySelector('.c-content-left')) {
                                var h2 = menu.querySelector('h2') ? menu.querySelector('h2').offsetHeight : 0,
                                    t = menu.getBoundingClientRect().top,
                                    f = this.$refs.footer.offsetHeight,
                                    all = h2 + t + f + 70;

                                menu.querySelector('.c-content-left').style.maxHeight = 'calc(100vh - ' + all + 'px)'
                            }
                        }
                    }
                }

                if (sort && header) {
                    if (type == 'down') {
                        if (sort.getBoundingClientRect().top - header.offsetHeight <= 0) {
                            sort.style.top = header.offsetHeight + 'px'
                            sort.style.position = 'fixed'

                            if (this.isMobileByWinWidth) {
                                sort.style.padding = "10px 0"
                            } else {
                                sort.style.padding = "10px"
                            }
                        }
                    } else {
                        if (e.target.scrollTop <= 20) {
                            sort.style.position = 'absolute'
                            sort.style.top = '0'
                            sort.style.padding = "0"
                        }
                    }
                }

                if (title && header) {
                    if (type == 'down') {
                        if (title.getBoundingClientRect().top - header.offsetHeight <= 0) {
                            title.style.top = header.offsetHeight + 'px'
                            title.style.position = 'fixed'

                            if (this.isMobileByWinWidth) {
                                title.style.padding = "10px 0"
                            } else {
                                title.style.paddingTop = "10px"
                            }
                        }
                    } else {
                        if (e.target.scrollTop <= 20) {
                            title.style.position = 'absolute'
                            title.style.top = '0'
                            title.style.padding = "0"
                        }
                    }
                }
            },
            async checkLogin () {
                this.userInfo = getStore({ name: 'userInfo' }) || { type: '' };

                if ((this.userInfo.type || '') == '') {
                    await this.handleOrganizationLogin();
                } else {
                    this.handelRefreshToken();
                    // if ((this.userInfo.type || '') == 'personal') {
                    this.handleOrganizationLogin(true);
                    // }

                }
            },
            async handleOrganizationLogin (onlyCheck) {
                if (onlyCheck == undefined) {
                    onlyCheck = false;
                }
                await this.request(this.API.organiztionLogin, {
                    method: 'post',
                    params: {
                        tenantId: "000000",
                        grant_type: "organization_ip"
                    },
                    headers: { "User-Type": "organization" }
                }).then(res => {
                    const data = res || {};
                    this.organiztionHasAuth = (data.type || '') != '';

                    // 无论用户是个人还是组织，都缓存他是不是组织
                    this.$store.commit('SETISGROUP', data.type == 'organization' ? 1 : 0)

                    if (onlyCheck) {
                        return;
                    } else {
                        if ((data.code || 200) == 401) {
                            this.clearToken();
                            return;
                        }
                    }

                    if ((data.error_description || '') != '') {
                        alert(data.error_description);
                    } else {
                        setToken(data.access_token);
                        setStore({ name: 'token', content: data.access_token })

                        setRefreshToken(data.refresh_token)
                        setStore({ name: 'refreshToken', content: data.refresh_token })

                        setStore({ name: 'tenantId', content: data.tenant_id })
                        setStore({ name: 'userInfo', content: data })


                        this.userInfo = data;
                        // window.location.href = "/";
                    }
                }).catch(err => {
                })
            },
            handelRefreshToken () {
                this.request(this.API.organiztionLogin,
                    {
                        method: 'post',
                        params: {
                            refresh_token: getRefreshToken(),
                            tenantId: '000000',
                            grant_type: "refresh_token",
                            scope: "all",
                            action: "refresh_token"
                        }
                    }
                ).then(res => {
                    const data = res || {};
                    // this.organiztionHasAuth = (data.type || '') == 'organization';
                    if ((data.code || 200) == 401) {
                        this.clearToken();
                        return;
                    }

                    setToken(data.access_token);
                    setStore({ name: 'token', content: data.access_token })

                    setRefreshToken(data.refresh_token)
                    setStore({ name: 'refreshToken', content: data.refresh_token })

                    setStore({ name: 'tenantId', content: data.tenant_id })
                    setStore({ name: 'userInfo', content: data })
                }).catch(error => {

                });
            },
            handlePersonalLogin () {
                this.userInfo = { nick_name: "", type: "" };

                this.goLogin()
                // this.clearToken();
                // if (window.location.href.lastIndexOf("localhost") > -1)
                //     window.location.href = "http://localhost:1889/#/portallogin";
                // else
                //     window.location.href = "/portal/#/portallogin";
            },
            handleLogout () {
                this.clearToken();
                window.location.href = "/";
            },
            clearToken () {
                this.userInfo = { nick_name: "", type: "" };
                removeStore({ name: 'userInfo' });
                removeStore({ name: 'token' });
                removeStore({ name: 'tenantId' });
                removeStore({ name: 'refreshToken' });
                removeToken();
                removeRefreshToken();
            }
        }),
        components: {
            Header,
            UpOutlined,
            ManageCookie
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    #body {
        transition: all 0.1s;
    }
    .c-header-container {
        padding: 0;
        height: auto;
    }
</style>